import { playSuccess, playTick } from "./audio";
import { state } from "./state";
import { countUp } from "./render";
import { hapticImpact, hapticNotification, tg } from "./telegram/sdk";

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function showToast(msg: string, type: "" | "success" | "error" = ""): void {
  const t = document.getElementById("toast");
  if (!t) return;
  t.textContent = msg;
  t.className = "toast show " + type;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    t.className = "toast " + type;
  }, 2400);
}

/** Real backend target per docs/API_CONTRACT.md: `POST /api/daily/claim`
 * (does not exist yet — see that file's "aspirational only" section).
 * This remains pure client-side demo state, exactly as before. */
export function claimDaily(): void {
  hapticImpact("medium");
  state.balance += 50;
  state.todayEarn += 50;
  const balanceNode = document.getElementById("balanceNum");
  if (balanceNode) countUp(balanceNode, state.balance);
  const todayNode = document.getElementById("todayEarn");
  if (todayNode) todayNode.textContent = state.todayEarn.toLocaleString();
  showToast("🎁 +50 ⭐ kunlik bonus qabul qilindi", "success");
  hapticNotification("success");
  playSuccess();
}

const TARIFF_LABELS: Record<string, string> = {
  starter: "Boshlang'ich",
  premium: "Premium",
  pro: "Pro",
};

/**
 * Real backend target: `tg.openInvoice(invoiceLink, callback)` once a
 * backend exists to create the invoice (it doesn't — see
 * docs/API_CONTRACT.md). The original had two branches
 * (`tg && tg.openInvoice` vs. else) that produced byte-identical output;
 * collapsed to one call here — not a behavior change, just removing
 * genuinely dead redundancy while porting.
 *
 * PHASE 6: the ceremony trigger below is SIMULATED — a fixed delay
 * standing in for the real `tg.openInvoice()` callback's `status ===
 * 'paid'` branch, which doesn't exist yet because there's no backend
 * invoice endpoint. Swap this setTimeout for that callback once one does;
 * everything downstream (runPurchaseCeremony's signature) stays the same.
 * ceremony.ts is dynamically imported — it's rare (one purchase, not
 * every tap) and has no reason to load before it's actually needed.
 */
export function buyStars(tariff: string, amount: number): void {
  hapticImpact("light");
  showToast(`💳 ${TARIFF_LABELS[tariff] ?? tariff} tarifi uchun to'lov tayyorlanmoqda...`);

  window.setTimeout(() => {
    import("./ceremony")
      .then(({ runPurchaseCeremony }) => {
        runPurchaseCeremony(TARIFF_LABELS[tariff] ?? tariff, amount);
      })
      .catch(() => {
        // PHASE 7: a failed chunk fetch here must not leave the user
        // wondering whether their purchase went through — this is the
        // one dynamic import in the app where silent failure (the 3D
        // crystal's pattern) is the wrong call.
        hapticNotification("error");
        showToast("⚠️ Nimadir xato ketdi, qayta urinib ko'ring", "error");
      });
  }, 1300);
}

export function copyRef(): void {
  const link = `https://t.me/${state.botUsername}?start=${state.id}`;
  navigator.clipboard?.writeText(link).catch(() => {});
  hapticImpact("light");
  playTick();
  showToast("🔗 Havola nusxalandi", "success");
}

export function shareRef(): void {
  const link = `https://t.me/${state.botUsername}?start=${state.id}`;
  const text = "StarBot orqali Telegram Stars sotib oling!";
  hapticImpact("light");
  if (tg?.openTelegramLink) {
    tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`);
  } else {
    showToast("Ulashish faqat Telegram ichida ishlaydi");
  }
}

export function openSupport(): void {
  if (tg?.openTelegramLink) {
    tg.openTelegramLink("https://t.me/yoursupport");
  } else {
    showToast("Qo’llab-quvvatlash: @yoursupport");
  }
}
